import { StyledEngineProvider } from '@mui/material/styles';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const environment = import.meta.env.VITE_SENTRY_ENVIRONMENT;

Sentry.init({
  dsn: 'https://83fe9f0f5d5256d3dc8fe2974ba079c9@o4508495368683520.ingest.de.sentry.io/4509128151466064',
  environment,
  tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </StrictMode>,
);
